import { render, staticRenderFns } from "./EmailSection.vue?vue&type=template&id=3b8501a7&scoped=true&"
import script from "./EmailSection.vue?vue&type=script&lang=js&"
export * from "./EmailSection.vue?vue&type=script&lang=js&"
import style0 from "./EmailSection.vue?vue&type=style&index=0&id=3b8501a7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8501a7",
  null
  
)

export default component.exports